import { selectDoesUserHaveRbacPermission } from 'core/userContext';
import { useSelector } from 'react-redux';
import { BUTTON_SIZES } from 'ui/button/constants';
import { Upload } from 'ui/icons';
import { LinkButton } from 'ui/linkButton';
import { PageHeader } from 'ui/pageHeader';
import { Tooltip } from 'ui/tooltip';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { ListActionsToolbar } from './ListActionsToolbar';

export const displayText = {
  title: 'Lists',
  cannotImportList:
    'You do not have permissions to import CSVs. A project administrator could change this.',
  importList: 'Import List',
};

export const DATA_TEST = {
  import: 'import-list-button',
};

export const Header = () => {
  const canManageSegmentation = useSelector(selectDoesUserHaveRbacPermission)(
    PROJECT_PERMISSIONS.ManageSegmentation,
  );

  return (
    <>
      <PageHeader
        pageActions={
          <Tooltip isEnabled={!canManageSegmentation} tooltipContent={displayText.cannotImportList}>
            <LinkButton
              data-test={DATA_TEST.import}
              isAngular
              isDisabled={!canManageSegmentation}
              size={BUTTON_SIZES.LARGE}
              to="/lists/import"
            >
              <Upload isColorInherited /> {displayText.importList}
            </LinkButton>
          </Tooltip>
        }
      >
        {displayText.title}
      </PageHeader>
      <ListActionsToolbar />
    </>
  );
};
